import makeApiRequest from './makeApiRequest'

const apiRequest = makeApiRequest()

export const getListSku = (filters) => {
    return apiRequest({
        url: 'sku/search',
        method: 'POST',
        data: filters
    })
}

export const addSku = async (payload) => {
    return apiRequest({
        url: `/sku`,
        method: 'POST',
        data: payload
    })
}

export const editSku = async (id, payload) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'PUT',
        data: payload
    })
}

export const deleteSku = async (id) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'DELETE',
    })
}

export const bulkDeleteSku = (data) => {
    return apiRequest({
        url: '/sku/bulk/delete',
        method: 'DELETE',
        data: data
    })
}

export const bulkUpdateStatus = (data) => {
    return apiRequest({
        url: '/sku/bulk/update-status',
        method: 'PUT',
        data: data
    })
}

export const getInfoSku = (id) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'GET'
    })
}

export const getSkuSizes = (id) => {
    return apiRequest({
        url: `/sku/${id}/sizes`,
        method: 'GET'
    })
}

export const getSkuSizesShippingCarrier = (id, payload = {}) => {
    return apiRequest({
        url: `/sku/${id}/sizes/shipping-carrier`,
        method: 'POST',
        data: payload
    })
}

export const deleteSizesSkuShippingCarrier = (id, shippingCarrier) => {
    return apiRequest({
        url: `/sku/${id}/shipping-carrier`,
        method: 'DELETE',
        data: shippingCarrier
    })
}

export const addSkuSize = (id, payload) => {
    return apiRequest({
        url: `/sku/${id}/sizes`,
        method: 'POST',
        data: payload
    })
}

export const updateSkuSize = (skuID, sizeID, payload) => {
    return apiRequest({
        url: `/sku/${skuID}/sizes/${sizeID}`,
        method: 'PUT',
        data: payload
    })
}

export const deleteSkuSize = (skuID, sizeID) => {
    return apiRequest({
        url: `/sku/${skuID}/sizes/${sizeID}`,
        method: 'DELETE',
    })
}

export const getHistory = (id) => {
    return apiRequest({
        url: `/sku/${id}/histories`,
        method: 'GET'
    })
}

export const updateMaterials = (id, payload) => {
    return apiRequest({
        url: `/sku/${id}/materials`,
        method: 'PUT',
        data: payload
    })
}

export const addShippingCarrierSku = (id, payload) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'POST',
        data: payload
    })
}

export const getShippingCarrierSku = (id) => {
    return apiRequest({
        url: `/sku/${id}/shipping-carrier`,
        method: 'GET'
    })
}

export const getListBrandSku = (id) => {
    return apiRequest({
        url: `/sku/${id}/brands`,
        method: 'GET'
    })
}

export const importSkuPrice = (payload) => {
    return apiRequest({
        url: `/base-cost/upload`,
        method: 'POST',
        data: payload
    })
}

export const importMaterial = (payload) => {
    return apiRequest({
        url: `/bulk-material`,
        method: 'POST',
        data: payload
    })
}

export const getListMaterials = (params) => {
    return apiRequest({
        url: `/materials`,
        method: 'GET',
        params
    })
}

export const getListProductionMethods = (params) => {
    return apiRequest({
        url: `/production-method`,
        method: 'GET',
        params
    })
}

export const createMaterial = (data) => {
    return apiRequest({
        url: `/materials/create`,
        method: 'POST',
        data
    })
}

export const updateMaterial = (data, id) => {
    return apiRequest({
        url: `/materials/${id}`,
        method: 'PUT',
        data
    })
}

export const getListProductionProcess = (params) => {
    return apiRequest({
        url: `/production/process`,
        method: 'GET',
        params
    })
}

export const getListProductionStage = (params) => {
    return apiRequest({
        url: `/production/stage`,
        method: 'GET',
        params
    })
}

export const getProductionProcessDetail = (id) => {
    return apiRequest({
        url: `/production/process/${id}`,
        method: 'GET',
    })
}

export const createProductProcess = (data) => {
    return apiRequest({
        url: `/production/process`,
        method: 'POST',
        data
    })
}

export const updateProductProcess = (data, id) => {
    return apiRequest({
        url: `/production/process/${id}`,
        method: 'PUT',
        data
    })
}

export const updateProcessStatus = (id) => {
    return apiRequest({
        url: `/production/processStatus/${id}`,
        method: 'PUT',
    })
}

export const getProductionProcess = (payload) => {
    return apiRequest({
        url: `/production/process`,
        method: 'GET',
        params: payload,
    })
}

export const addNewTabSku = (id, objectType, objectName) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}/clone`,
        method: 'POST',
    })
}

export const getSkuSizesTab = (id, objectType, objectName) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}`,
        method: 'GET'
    })
}

export const deleteSizesSkuTab = (id, objectType, objectName) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}`,
        method: 'DELETE',
    })
}

export const getListTab = (id) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/optimization`,
        method: 'GET'
    })
}

export const addSkuSizeV2 = (id, objectType, objectName, payload) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}`,
        method: 'POST',
        data: payload
    })
}

export const uploadImageSku = (data) => {
    return apiRequest({
        url: `/sku/upload-mockup`,
        method: 'POST',
        data
    })
}

export const getAllProductType = (params) => {
    return apiRequest({
        url: '/sku/product-type',
        method: 'GET',
        params
    })
}

export const getListCatalog = async ( payload) => {
    const {data} = await apiRequest({
        url: `/sku-catalog/getList`,
        method: 'POST',
        data: payload
    })

    return data
}